/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Ajouter"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Tout supprimer"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var frFR = Object.assign(TranslationProviderComponent, {
  translations
});

export { frFR as f };
//# sourceMappingURL=fr-FR-Bov978eS.js.map
